import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

interface Props {
	isEnabled?: boolean;
}

export const StepCircleIcon = ({ isEnabled = false }: Props) => {
	const color = {
		circle: isEnabled ? defaultTheme.v3.colors.blue[0] : defaultTheme.v3.colors.gray[2],
		innerCircle: isEnabled ? defaultTheme.v3.colors.blue[6] : defaultTheme.v3.colors.gray[8],
	};
	return (
		<div className="rounded-2xl w-8 h-8 relative" style={{ backgroundColor: color.circle }}>
			<div
				className="rounded-2xl w-2.5 h-2.5 absolute left-1/2 top-1/2"
				style={{ backgroundColor: color.innerCircle, transform: 'translate(-50%, -50%)' }}
			></div>
		</div>
	);
};
